export const KOT_DIRTY_ROUTE_PREFIXES = ["/kot/client/", "/kot/track-changes/"];

export const isKotDirtyRoute = (path) => Boolean(path && KOT_DIRTY_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix)));

export const emitKotFormDirty = () => {
  window.dispatchEvent(new Event("kot-form-dirty"));
};

export const emitKotFormSaved = () => {
  window.dispatchEvent(new Event("kot-form-saved"));
};

export const emitKotFormReset = () => {
  window.dispatchEvent(new Event("kot-form-reset"));
};
